/**
 * Canonical admin staff roles (users.admin_role / JWT adminRole).
 * Legacy Cognito group names map to these for CASL + API.
 */

export const ADMIN_ROLES = [
  "super_admin",
  "moderator",
  "support",
  "finance",
  "showroom_admin",
  "realestate_admin",
  "auction_admin"
]

const LEGACY_TO_CANONICAL = {
  superadmins: "super_admin",
  admins: "super_admin",
  admin: "super_admin",
  manager: "super_admin",
  supervisors: "moderator",
  accountant: "finance",
  stuffs: "moderator",
  realestate_staff: "realestate_admin",
  showroom_staff: "showroom_admin"
}

export const canonicalAdminRole = (raw) => {
  const s = String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/-/g, "_")
  if (ADMIN_ROLES.includes(s)) return s
  if (LEGACY_TO_CANONICAL[s]) return LEGACY_TO_CANONICAL[s]
  return "super_admin"
}

/** CASL ability list keys (see list_ability.js) */
export const abilityGroupsFromRole = (raw) => {
  const role = canonicalAdminRole(raw)
  return [role]
}

export const groupsFromJwtPayload = (payload = {}) => {
  const role = canonicalAdminRole(payload.adminRole || payload.admin_role)
  return [role]
}

export const isAdminDashboardUser = (groups = []) => {
  const list = Array.isArray(groups) ? groups : [groups]
  return list.some((g) => {
    const c = canonicalAdminRole(g)
    return ADMIN_ROLES.includes(c) || String(g).toLowerCase().includes("admin")
  })
}
